<template>
  <header class="fixed_Back_header flx">
    <div class="menu flx">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="16"
        viewBox="0 0 20 16"
        @click="goBack()"
        v-if="showBackButton"
      >
        <g fill="#FFF" fill-rule="evenodd">
          <path
            d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
          />
          <path
            d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
          />
        </g>
      </svg>
      <h3>{{detail_page_text}}</h3>
    </div>
  </header>
</template>

<script>
export default {
  name: "BackHeader",
props:{
  detail_back_header:{
    type:String
  }
},
  data() {
    return {
      detail_page_text: "",
      showBackButton: true
    };
  },
  watch: {
    detail_back_header() {
      if (this.$route.query.type || this.$route.params.mid) {
        this.detail_page_text = this.$t("productList");
      } else if (this.$route.params.preOrderId) {
        this.detail_page_text = this.$t("orderDetail");
      } else if (
        this.$route.params.orderId &&
        this.$route.name != "ProductReturn" && this.$route.name != "OrderSuccess" && this.$route.name != "TrackOrder" && this.$route.name != "NearPayOrderDetails"
      ) {
        this.detail_page_text = this.$t("shippingDetail");
      } else if (this.$route.name === "ProductReturn") {
        this.detail_page_text = this.$t("returnItem");
      } else if (this.$route.name === "NearPayOrderDetails") {
        this.detail_page_text = this.$t("paymentDetail");
      } else if (this.$route.name === "GroupsProductListing") {
        this.detail_page_text = this.$t('groupListing');
      } else if (this.$route.name === "CutThePriceProductListing") {
        this.detail_page_text = this.$t('cutThePrice');
      } else if (this.$route.name === "OrderSuccess") {
        this.detail_page_text = "";
      } else if (this.$route.name === "TrackOrder") {
        this.detail_page_text = this.$t('trackOrderHead');
      } else if (this.$route.name === "ProductComment") {
        this.detail_page_text = this.$t('prductComment');
      } else if (this.$route.query.subCategoryname) {
        this.detail_page_text = this.$route.query.subCategoryname;
      } else {
        this.detail_page_text = this.$t("productDetail");
      }
    }
  },
  created() {
    if (this.$route.query.type || this.$route.params.mid) {
        this.detail_page_text = this.$t("productList");
      } else if (this.$route.params.preOrderId) {
        this.detail_page_text = this.$t("orderDetail");
      } else if (
        this.$route.params.orderId &&
        this.$route.name != "ProductReturn" && this.$route.name != "OrderSuccess" && this.$route.name != "TrackOrder"&& this.$route.name != "NearPayOrderDetails"
      ) {
        this.detail_page_text = this.$t("shippingDetail");
      } else if (this.$route.name === "ProductReturn") {
        this.detail_page_text = this.$t("returnItem");
      } else if (this.$route.name === "NearPayOrderDetails") {
        this.detail_page_text = this.$t("paymentDetail");
      } else if (this.$route.name === "GroupsProductListing") {
        this.detail_page_text = this.$t('groupListing');
      } else if (this.$route.name === "CutThePriceProductListing") {
        this.detail_page_text = this.$t('cutThePrice');
      } else if (this.$route.name === "OrderSuccess") {
        this.detail_page_text = "";
      } else if (this.$route.name === "TrackOrder") {
        this.detail_page_text = this.$t('trackOrderHead');
      } else if (this.$route.name === "ProductComment") {
        this.detail_page_text = this.$t('prductComment');
      } else if (this.$route.query.subCategoryname) {
        this.detail_page_text = this.$route.query.subCategoryname;
      } else {
        this.detail_page_text = this.$t("productDetail");
      }
    let [, , dukaanId] = window.location.pathname.split("/");
    if (window.location.pathname === `/dukaan/${dukaanId}/`) {
      this.showBackButton = false;
    }
  },
  methods: {
    goBack() {
      if (this.$cookie.get("version-code") > 57) {
        if (window.history.length == 1) {
          try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    }
  },
};
</script>
    